import { trigger, transition, style, animate } from '@angular/animations';

export const unitDashboardCallEventAnimations = [
    trigger('slideToggle', [
        transition(':enter', [
            style({
                height: '0',
                opacity: 0,
                overflow: 'hidden',
                paddingTop: '0',
                marginTop: '0',
                borderTopWidth: '0'
            }),
            animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({
                height: '*',
                opacity: 1,
                paddingTop: '12px',
                marginTop: '12px',
                borderTopWidth: '1px'
            }))
        ]),
        transition(':leave', [
            style({ overflow: 'hidden' }),
            animate('250ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({
                height: '0',
                opacity: 0,
                paddingTop: '0',
                marginTop: '0',
                borderTopWidth: '0'
            }))
        ])
    ])
];
